import { getEditLocation } from "../../../core/util/functions";

export const mainBoardLocation = "/foreign/mainpanel"
